import { useContext } from "react";
import context from "../../store/context";

const CategoryButton = (props) => {
  const { searchIsClicked } = useContext(context);
  const isActive =
    (Number(props.clickedId) === props.id ||
      (Number(props.clickedId) === 0 && props.id === "")) &&
    !searchIsClicked;

  return (
    <button
      id={props.id}
      onClick={props.onClick}
      className={`min-w-max rounded-full px-4 h-[30px] md:h-[35px] flex items-center gap-1.5 text-sm font-medium transition-colors ${
        isActive
          ? "bg-[#664bc7] text-white shadow-sm"
          : "bg-[#664bc7]/5 text-[#664bc7] ring-1 ring-[#664bc7]/15 hover:bg-[#664bc7]/10"
      }`}
    >
      {props.children}
      <span>{props.name}</span>
    </button>
  );
};

export default CategoryButton;
